package com.essntl.features.proposal.ui.proposalhistory.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatNumber
import core.dateformat.utils.formatTimestampToHHMM
import com.essntl.core.utils.utils.capitalizeFirstLetter
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalTime

@Composable
fun ProposalJourneyDayRow(
    day: String,
    localDate: LocalDate,
    proposalServiceList: List<JourneyRowUiState>,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(3.spacing),
        modifier = Modifier
            .fillMaxWidth()
            .border(
                width = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
            )
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(
                color = MaterialTheme.esColorScheme.bgPrimary,
            )
            .padding(1.5f.spacing),
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(1.spacing),
        ) {
            Text(
                text = day,
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.s2SemiBold16,
            )

            val monthString = localDate.month.name.lowercase().capitalizeFirstLetter().take(3)
            val dayString = formatNumber(localDate.dayOfMonth)

            Text(
                text = "$monthString $dayString",
                color = MaterialTheme.esColorScheme.primary,
                style = MaterialTheme.esTypography.p2Regular14,
            )
        }

        Column(
            verticalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier
                .weight(1f),
        ) {
            proposalServiceList.sortedBy {
                it.startTime?.let { time ->
                    LocalTime.parse(formatTimestampToHHMM(time))
                }
            }
                .forEach { proposalService ->
                    key(proposalService.id) {
                        ProposalJourneyDayService(
                            service = proposalService.service,
                            proposalService = proposalService,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                }
        }
    }
}